import { Model, Utilities } from '@socrates/common';
import { SearchOptions } from './SearchOptions';
import { ILocalRecordFilter } from './ILocalRecordFilter';

export class LocalRecordFilter implements ILocalRecordFilter {
	public searchRecords<T extends Model>(allRecords: T[], searchOptions: SearchOptions): T[] {
		let records: T[] = allRecords;

		const uniqueSearchTerms: any[] = searchOptions.marshallLocalSearchTerms();
		uniqueSearchTerms.forEach(
			(searchElement: any) => {
				if (searchElement.isAny) {
					records = Utilities.filter(allRecords, searchElement.searchTerm);
				} else {
					records = Utilities.filter(allRecords, searchElement.searchTerm, searchElement.fields);
				}
			}
		);
		if (searchOptions.startDate && searchOptions.startDateField) {
			records = records.filter(
				(record: T) => {
					return record[searchOptions.startDateField] >= searchOptions.startDate;
				}
			);
		}
		if (searchOptions.endDate && searchOptions.endDateField) {
			records = records.filter(
				(record: T) => {
					return record[searchOptions.endDateField] <= searchOptions.endDate;
				}
			);
		}

		if (searchOptions.sortOrder && searchOptions.sortOrder.length > 0) {
			records = Utilities.sorter<T>(records, searchOptions.localFieldsSortOrder);
		}
		return records;
	}
}
